var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('v-container',{staticClass:"overflow-y-auto",attrs:{"id":"scroll-target","fluid":""}},[_c('v-row',{attrs:{"align":"center","justify":"center"}},[_c('v-col',{attrs:{"id":"drawing"}})],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }